import React from "react"

const loves = [
    "locks 🔒",
    "rpgmaker 🎮",
    "highway 🛣️",
    "drawing 🖊",
]
const WilliamAge = ()=> (<span>
    {"the " + Math.floor(((new Date()) - (new Date(2015, 4, 2)))/(365.0*24.0*3600.0*1000.0))}
    {`-years-old son loves ${loves[Math.floor(Math.random()*loves.length)]}`}
</span>)

export default WilliamAge

